import React, { useEffect, useState } from "react";
import { useOrderContext } from "../../contexts";
import { Link, useNavigate } from "react-router-dom";
import { HeaderText, Button, ProductCard } from "../";
import { createBrowserHistory } from "history";
import { useDispatch, useSelector } from "react-redux";
import { updateSetting, setProductDetails } from "../../redux/slices";
import { storeSettingTypes, productActionTypes } from "../../redux/utils";

export const ItemGrid = () => {
  const [isBtnDisabled, setIsBtnDisabled] = useState(true);
  const { setOrderInfo, setIsSelected, setVariantID, setSelectReturnItem } =
    useOrderContext();
  const history = createBrowserHistory();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const productDetailsState = useSelector((state) => state.productDetails);
  const storeConfigState = useSelector((state) => state.storeSettings);

  /*clearing the  selected item and navigate to reason */
  const buttonHandler = () => {
    setSelectReturnItem(null);
    navigate("/reason");
  };

  /* navigate to previous page */
  const backHandler = () => {
    window.history.back();
  };

  useEffect(() => {
    return history.listen(() => {
      if (history.action === "POP") {
        navigate("/");
      }

      dispatch(
        updateSetting({
          key: storeSettingTypes.UPDATE_IS_JOHN_DOE_TEST_MODE,
          value: false,
        })
      );
    });
  }, []);

  return (
    <div className="saara-item-container">
      <div className="saara-item-heading">
        <div>
          <Link to="" onClick={backHandler} className="backIcon">
            <img src="assets/svg/chevron_left.svg" width="24" alt="back" />
          </Link>
        </div>

        <HeaderText
          text={storeConfigState?.themeConfig?.item_selection_page_title}
        />
      </div>
      <div className="saara-item-main">
        <ProductCard
          orderInfo={productDetailsState?.orderInfo}
          setIsSelected={setIsSelected}
          setOrderInfo={setOrderInfo}
          setVariantID={setVariantID}
          setIsBtnDisabled={setIsBtnDisabled}
        />
      </div>
      <div className="btns">
        <div className=" btn__big_screen margin-right-20">
          <button
            className="saara_custom_btn saara__btn btn__back back_page"
            onClick={backHandler}
          >
            {storeConfigState?.themeConfig?.back_button_label}
          </button>
        </div>

        <div>
          <Button
            name={storeConfigState?.themeConfig?.continue_button_label}
            onClick={buttonHandler}
            disabled={isBtnDisabled}
          />
        </div>
      </div>
    </div>
  );
};
